module.exports = __webpack_public_path__ + "static/sign-972f328cb0b0f3ed9595f333668e05bb.png";